import { type as types } from "../types/index";

const initialState = { isOlvido: false, errorMessage: null, dataOlvido: {
    paso: 1,
    email: ""
} }

export const OlvidoContraseniaReducer = (state = initialState, action) => {
    const {type, payload } = action;
    switch(type){
        
        case types.olvidoEnvioContraseniaTem:
            return {
                ...state,
                isOlvido: true,
                dataOlvido: payload
            };
        case types.olvidoEnvioContraseniaTemFail:
            return {
                ...state,
                isOlvido: false,
                dataOlvido: null
            }
        case types.olvidoActContrasenia:
            return {
                ...state,
                isOlvido: true,
                dataOlvido: payload
            }
        case types.olvidoActContraseniaFail:
            return payload;
        default:
            return state;
    }
}